//React-RTK
import { BrowserRouter } from 'react-router-dom';
import AuthLogin from './features/Auth/AuthLogin';

// MUI
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

//Theme
import { Theme } from '@abi-labs-hexa/web-v2/core/theme';
import anheuserBusch22 from './themes/abTheme/anheuserBusch22';

import { useEmptyApiErrorEnhancements } from './api/priceApi/emptyApi';
import { priceApi } from './api/priceApi/priceApi';
import AllRoutes from './routes/AllRoutes';

const theme = anheuserBusch22;

//Root component for the PRC Application
const App = () => {
  useEmptyApiErrorEnhancements(priceApi);

  return (
    /*
        StylesProvider is used to set the CSS injection order for mui https://mui.com/material-ui/guides/interoperability/#css-injection-order
        This is needed to allow other CSS and styling systems to override MUI 
  */ <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Theme>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AuthLogin>
              <BrowserRouter>
                <AllRoutes />
              </BrowserRouter>
            </AuthLogin>
          </LocalizationProvider>
        </Theme>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
